import { gql, TypedDocumentNode } from '@common/hooks';
import {
  LoadBalancingProjectedUnassignedShiftCountQueryCgResponse,
  LoadBalancingProjectedUnassignedShiftCountQueryVariables,
} from '@common/graphql';

export const PROJECTED_UNASSIGNED_SHIFT_COUNT_QUERY: TypedDocumentNode<
  LoadBalancingProjectedUnassignedShiftCountQueryCgResponse,
  LoadBalancingProjectedUnassignedShiftCountQueryVariables
> = gql`
  query LoadBalancingProjectedUnassignedShiftCount(
    $id: ID!
    $scheduleGroupId: ID!
    $effectiveStartDate: ISO8601Date!
    $effectiveEndDate: ISO8601Date
  ) {
    loadBalancingWorker(id: $id, serviceLineId: $scheduleGroupId) {
      id
      projectedUnassignedShiftCount(
        effectiveStartDate: $effectiveStartDate
        effectiveEndDate: $effectiveEndDate
      )
    }
  }
`;
